import React from 'react';
import { Menu as MuiMenu } from '@material-ui/core';

export default function Menu(props) {
  return (
    <MuiMenu
      {...props}
      disableScrollLock
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    />
  );
}
